// extracted by mini-css-extract-plugin
export default {"mainB":"Uuid_mainB__cD6EO","idImage":"Uuid_idImage__Sr1Xk"};